export interface ArticleDiscount {
    id: string;
    name: string;
    externalId: string;
    description: string;
    discountPercentage: number;
    forcedSalesPrice: string | null;
    createdAt: Date | null;
    updatedAt: Date | null;
}

export const defaultArticleDiscount: ArticleDiscount =
{
    id: "",
    name: "",
    externalId: "",
    description: "",
    discountPercentage: 0,
    forcedSalesPrice: null,
    createdAt: null,
    updatedAt: null
}